import toast from "react-hot-toast";

export default function handleError(error) {
  if (!error) return;

  if (error.response?.status === 401) {
    window.location.href = "/login";
  } else {
    console.error(error);
    toast.error(error.message);
  }
}
